import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onAppBarTrigger, onOpenAboutDialog, onOpenPreviewDialog } from 'owa-nova-actions';
import onModuleClick from 'owa-left-rail-utils/lib/actions/onModuleClick';
import onRefreshAppBarData from 'owa-appbar-state/lib/actions/onRefreshAppBarData';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "AppBar" */ './lazyIndex'));

registerLazyOrchestrator(onOpenPreviewDialog, lazyModule, m => m.onAppPreviewOrchestrator);
registerLazyOrchestrator(onOpenAboutDialog, lazyModule, m => m.onOpenAboutDialogOrchestrator);
registerLazyOrchestrator(onAppBarTrigger, lazyModule, m => m.appBarCommandingOrchestrator);
registerLazyOrchestrator(onModuleClick, lazyModule, m => m.onModuleClickOrchestrator);
registerLazyOrchestrator(onRefreshAppBarData, lazyModule, m => m.onRefreshAppBarDataOrchestrator);

export { default as AppBar } from './components/AppBar';
export { isAppBarEnabledForModule } from './utils/isAppBarEnabledForModule';
